import * as S from "./Modal.style";
import { ReactComponent as WarningIcon } from "assets/icons/warning.svg";
import { GENERIC_SERVICE_ERROR } from "constants/errors";

const Modal = ({
  error,
  errorMessage,
  retry,
  closeOnRetry,
  open,
  onClose,
  children,
  ...props
}) => {
  if (error) {
    return (
      <S.GenericModal
        open={open}
        lead="Erro"
        data-setion="erro"
        className="make-section"
        title={
          <>
            <WarningIcon />
            Ops, algo deu errado :(
          </>
        }
        description={errorMessage || GENERIC_SERVICE_ERROR}
        primaryActionProps={
          retry && {
            className: "make-click",
            text: "Tentar novamente",
            onClick: () => {
              retry();
              if (closeOnRetry) {
                onclose?.();
              }
            },
          }
        }
        closeActionProps={{
          className: "make-click",
          text: "Fechar",
        }}
        onClose={() => onClose?.()}
      >
        {children}
      </S.GenericModal>
    );
  }
  return (
    <S.GenericModal
      open={open}
      {...props}
      closeActionProps={{
        className: "make-click",
        text: "Fechar",
        ...(props?.closeActionProps || {}),
      }}
      onClose={() => onClose?.()}
    >
      {children}
    </S.GenericModal>
  );
};

export default Modal;
